// [init]

export default {


	namespaced: true,

	state: {
		// Listing of all admins ( Array )
		adminsList: [],

		// Current Admin being manipulated ( viewed or edited ) ( Object )
		status: '',
		activeAdmin: {}
	},

	mutations: {

		// Update adminList with new list
		// @params: Array
		updateAdminList( state, newList ) {
			state.adminsList = newList;
		},

		// Add a admin into adminList
		addAdmin( state, newAdmin ) {
			state.adminsList.push( newAdmin );
		},

		// Delete a admin from adminList
		// @params: identifier (String)
		deleteAdmin( state, identifier ) {
			state.adminsList = state.adminsList.filter( admin => {
				return admin.id != identifier;
			} );
		},

		// Update the current active Admin object
		// @params: newActiveAdmin (Object)
		updateActiveAdmin( state, newActiveAdmin ) {
			state.activeAdmin = newActiveAdmin;
		},

		// Change status of adminForm
		// @params: newStatus (String)
		updateStatus( state, newStatus ) {
			state.status = newStatus;
		},

		resetState( state ) {
			state.activeAdmin = {};
			state.status = '';
		}

	},

	actions: {
		
		/* 
		*  /GET admins API
		*  Get all admins from the server
		*  @return: Array
		*/
		getAdmins( { commit, state } ) {

			return new Promise (( resolve, reject ) => {

				global.axios.request({
					method: 'get',
					url: '/admins',
					params: {
						trash: '*',
						from: 0,
						size: 9999999
					},
					validateStatus: ( status ) => { return status == 200; }
				})
				.then(response => {
					commit( 'updateAdminList', response.data );
					resolve( response );
				})
				.catch(error => reject( error ));

			});

		},

		/* 
		*  /GET/:id admins API
		*  Get a single admin from the server
		*  @params: Array (due to vuex limitations)
		*  [0]: identifier (String)
		*  [1]: action (String: view/edit)
		*  @return: Object
		*/
		getSingleAdmin( { commit, state }, params ) {

			const identifier = params[0];
			const action = params[1];

			return new Promise ( (resolve, reject ) => {

				global.axios.request({
					method: 'get',
					url: '/admins/' + identifier,
					validateStatus: ( status ) => { return status == 200; }
				})
				.then(response => {
					commit( 'resetState' );
					commit( 'updateActiveAdmin', response.data );
					commit( 'updateStatus', action );
					resolve( response );
				})
				.catch(error => reject( error ));

			});

		},

		/* 
		*  /POST admins API
		*  Add a new admin to the server
		*  @params: Object (admins data)
		*  @return: Object
		*/
		addAdmin( { commit, state }, data ) {

			return new Promise ( (resolve, reject ) => {

				const postData = {
					identity: data.identity,
					password: data.password,
					fullname: data.fullname,
					email: data.email
				};

				global.axios.request({
					method: 'post',
					url: '/admins',
					validateStatus: ( status ) => { return status == 201; },
					data: postData
				})
				.then(response => {
					commit( 'addAdmin', response.data );
					resolve( response );
				})
				.catch(error => reject( error ));

			});


		},

		/* 
		*  /POST/:id admins API
		*  Edits an existing admin into the server
		*  @params: Object (admins data)
		*  @return: Object
		*/
		editAdmin( { commit, state }, data ) {

			return new Promise ((resolve, reject ) => {

				const postData = {
					identity: data.identity,
					password: data.password,
					fullname: data.fullname,
					email: data.email
				};

				global.axios.request({
					method: 'post',
					url: '/admins/' + data.id + '/update',
					validateStatus: ( status ) => { return status == 200; },
					data: postData
				})
				.then(response => {
					commit( 'addAdmin', response.data );
					resolve( response );
				})
				.catch(error => reject( error ));

			});

		},

		/* 
		*  /DELETE/:id admins API
		*  Removes an existing admin into the server
		*  @params: identifier (String)
		*  @return: 200 OK
		*/
		deleteAdmin( { commit, state }, identifier ) {

			return new Promise ((resolve, reject ) => {

				global.axios.request({
					method: 'post',
					url: '/admins/' + identifier + '/trash',
					validateStatus: ( status ) => { return status == 200; }
				})
				.then(response => {
					commit( 'deleteAdmin', identifier );
					resolve( response );
				})
				.catch(error => reject( error ));

			});

		},

		/* 
		*  /POST/:id/untrash admins API
		*  Restores a admin into the server from the trash
		*  @params: identifier (String)
		*  @return: 200 OK
		*/
		untrashAdmin( { commit, state }, identifier ) {

			return new Promise ( (resolve, reject) => {

				global.axios.request({
					method: 'post',
					url: '/admins/' + identifier + '/untrash',
					validateStatus: ( status ) => { return status == 200; },
				})
				.then(response => {
					const updatedList = state.adminsList.map(item => {
						if (item.id === identifier ) {
							let holder = item;
							holder.trash = 0;
							return holder;
						} else {
							return item;
						};
					});
					commit( 'updateAdminList', updatedList );
				})
				.catch(error => reject( error ));

			});

		},

		reset( { commit, state } ) {
			commit( 'resetState' );
		}

	}
}


// WEBPACK FOOTER //
// ./src/custom/controllers/Admins.js